import { useIntl } from 'react-intl'

export default useIntl
